import BeSafeSeparator from "components/commons/BeSafeSeparator";

const ConfigurationTitle = (props) => {

  return (
    <>
      <div className="d-flex justify-content-between">
        <span className='text-primary text-uppercase'>
          {props.text}
        </span>
        <div>
          {props.buttons}
        </div>
      </div>
      <div>
        <BeSafeSeparator />
      </div>
    </>
  );
};

export default ConfigurationTitle;
